export enum UserFormType {
  // caregiver
  EditCurrentUser = 'edit-current-user',
  ReadOnlyCaregiver_ProfessionalCaregiverAdministrator = 'read-only-caregiver_professional-caregiver-administrator',
  EditCaregiver_SystemAdministrator = 'edit-caregiver_system-administrator',

  // senior
  CreateEditRemoveSenior_ProfessionalCaregiver = 'create-edit-remove-senior_professional-caregiver',
  CreateEditRemoveSenior_SystemAdministrator = 'create-edit-remove-senior_system-administrator',

  // senior and caregiver
  ReadOnlyCaregiver_ProfessionalCaregiverManagerAndOperator = 'read-only-caregiver_professional-caregiver-manager-and-operator',
}
